import React, { useState, useEffect, useRef } from 'react';
import clsx from 'clsx';
import Icona from '../../../components/3catinfo/ui/Icona/Icona';
import Modal from './Modal';
import { useUser } from '../../../hooks/useUser';
import { hitAudiencies } from 'components/3catinfo/Audiencies/audiencies-datalayer';
import { useLaMevaLlista } from '../../../hooks/3catinfo/useLaMevaLlista';
import { useViewport } from '../../../hooks/3catinfo/useViewport';
import styles from './afegeixalallista.module.scss';
import { useModal } from '../../../hooks/3catinfo/useModal';
import useIsServiceEnabled from 'hooks/useIsServiceEnabled';
import ModalContent from '../../../components/3catinfo/AreaUsuaris/ModalNoLogat';
import __isEmpty from 'lodash/isEmpty';

function AfegeixALaLlista(props) {
    const {
        obreEsquerra,
        estil,
        tipologia,
        id,
        className,
        accioMostraAfegirBookmark,
        mida,
        textTooltipInactiu,
        showMissatgeEliminat,
        audiencies
    } = props;

    const { setModal } = useModal();
    const { isMobile } = useViewport();
    const isMounted = useRef(true);

    const { isAuthenticated } = useUser();
    const isVrEnabled = useIsServiceEnabled('videos-recomanats');
    const isRmEnabled = useIsServiceEnabled('resume-media');
    const isSpmEnabled = isVrEnabled && isRmEnabled;
    const { isALaMevaLlista, toggleSelection } = useLaMevaLlista();
    const isItemInLlista = isALaMevaLlista(id, tipologia);
    const [showModal, setShowModal] = useState(false);
    const [hoverModal, setHoverModal] = useState(false);
    const hoverModalRef = useRef(hoverModal);
    const modalRef = useRef(null);
    const [isTimeoutActive, setIsTimeoutActive] = useState(false);

    const stylesAfegir = clsx({
        [styles.afegeix]: true,
        [className]: !!className,
        [styles[estil]]: !!estil,
        [styles[mida]]: !!mida
    });

    const stylesOverlay = clsx({
        [styles.overlay]: true,
        [styles.esquerra]: obreEsquerra && !isMobile,
        [styles.negatiu]: estil === 'negatiu' && !isMobile,
        [styles.leftModal]: !!className,
        [styles.forMobile]: isMobile
    });

    const stylesBoto = clsx({
        [styles.botoNegatiu]: isItemInLlista && estil === 'negatiu',
        [styles.boto]: isItemInLlista && estil !== 'negatiu',
        [styles.botoUnmarked]: !isItemInLlista && estil !== 'negatiu',
        [styles.botoUnmarkedNegatiu]: !isItemInLlista && estil === 'negatiu',
        [styles.hover_boto]: !!hoverModal
    });

    useEffect(() => {
        hoverModalRef.current = hoverModal;
    }, [hoverModal]);

    let bookMarkActive = isALaMevaLlista(id, tipologia);
    useEffect(() => {
        isMounted.current = true;
        return () => {
            isMounted.current = false;
            if (modalRef.current) {
                clearTimeout(modalRef.current);
            }
        };
    }, []);
    const elmTresCatinfo = <span className={styles.bold}>El meu 3CatInfo</span>;
    const altIcona = isItemInLlista ? (
        <> Elimina d&#39;{elmTresCatinfo} </>
    ) : (
        (textTooltipInactiu && <>textTooltipInactiu</>) || <>Afegeix a&nbsp;{elmTresCatinfo}</>
    );
    const ariaLabel = isItemInLlista ? 'Elimina d&#39;El meu 3CatInfo' : textTooltipInactiu || 'Afegeix a El meu 3CatInfo';

    const showModalNoLogat = () => {
        setModal(<ModalContent />, { className: styles.modal });
    };

    const onActionToList = async () => {
        if (!isAuthenticated) {
            showModalNoLogat();
            return;
        }
        setHoverModal(false);
        setShowModal(true);
        const result = await toggleSelection(id, tipologia);
        bookMarkActive = !isItemInLlista;

        if (result) {
            if (tipologia === 'NOT_NOTICIA' && !isItemInLlista) {
                hitAudiencies('scPerMesTard', {
                    ...audiencies,
                    URL: window.location.href
                });
            }
            if (!!accioMostraAfegirBookmark) {
                accioMostraAfegirBookmark(!isItemInLlista, id);
            }
        }

        setIsTimeoutActive(true);
        modalRef.current = setTimeout(() => {
            if (isMounted.current) {
                if (!hoverModalRef.current) {
                    setShowModal(false);
                }
                setIsTimeoutActive(false);
            }
        }, 2000);
    };

    const handleMouseOut = () => {
        if (!isTimeoutActive || hoverModal) {
            setShowModal(false);
            setHoverModal(false);
        }
    };

    const textContent = (isItemInLlista, textTooltipInactiu) => {
        let textContent;
        if (hoverModal && isItemInLlista) {
            textContent = <>Elimina d&#39;{elmTresCatinfo}</>;
        } else if (hoverModal && !isItemInLlista) {
            textContent = (!__isEmpty(textTooltipInactiu) && <>{textTooltipInactiu}</>) || <>Afegeix a&nbsp; {elmTresCatinfo}</>;
        } else if (!hoverModal && isItemInLlista) {
            textContent = (isMobile && <>Not&#237;cia guardada a&nbsp;{elmTresCatinfo}</>) || (
                <>S&#39;ha guardat a&nbsp; {elmTresCatinfo}</>
            );
        } else if (showMissatgeEliminat) {
            textContent = <>S&#39;ha eliminat d&#39;{elmTresCatinfo}</>;
        }
        return textContent;
    };

    const textFinal = textContent(isItemInLlista, textTooltipInactiu);

    return isSpmEnabled ? (
        <div className={stylesAfegir}>
            <button
                className={stylesBoto}
                aria-label={ariaLabel}
                onClick={() => {
                    setHoverModal(false);
                    onActionToList();
                }}
                onMouseEnter={() => {
                    clearTimeout(modalRef.current);
                    setHoverModal(true);
                    setShowModal(true);
                }}
                onFocus={() => {
                    clearTimeout(modalRef.current);
                    setHoverModal(true);
                    setShowModal(true);
                }}
                onMouseLeave={handleMouseOut}
                onBlur={handleMouseOut}
                data-testid='afegeix-a-la-llista'
            >
                <Icona
                    className={styles.icona}
                    icona={bookMarkActive ? 'bookmark-active' : 'bookmark'} // Cambia el icono
                    alt={altIcona}
                    inline={true}
                />
            </button>
            {showModal && textFinal && (
                <div ref={modalRef}>
                    <Modal isOpen={showModal}>
                        <div className={stylesOverlay}>{textFinal}</div>
                    </Modal>
                </div>
            )}
        </div>
    ) : (
        <></>
    );
}

AfegeixALaLlista.defaultProps = {
    audiencies: {},
    obreEsquerra: true,
    showMissatgeEliminat: true
};

export default React.memo(AfegeixALaLlista);
